import { productListAttributeFiltersStyles } from "@insite/content-library/Widgets/ProductList/ProductListAttributeFilters";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { COLORS, SPACING } from "@store/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(productListAttributeFiltersStyles, {
    ...productListAttributeFiltersStyles,
    accordionSection: {
        headerProps: {
            css: css`
                button {
                    background-color: transparent;
                }
            `,
        },
    },
});
